import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import logolight from "../../assets/images/logotop.png";
import logodark from "../../assets/images/logotop.png";

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Social Media Imports
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithCredential,
} from "firebase/auth";
import { auth } from "../../firebase";

// actions
import { apiError, loginUser, socialLogin } from "../../store/actions";

//Import config
import { facebook, google } from "../../config";

import { isGmail } from "../../helpers/authErrors";
import { GmailNotice, GoogleButton, PasswordInput } from "./AuthComponents";

const Login = (props) => {
  document.title = "Login | TicketControl - Monitor";

  const dispatch = useDispatch();

  // Con un Gmail escrito, el aviso de Google ocupa el lugar del campo de
  // clave. Esto lo devuelve para quien igual entra con una clave de Monitor.
  const [usePassword, setUsePassword] = useState(false);
  const alertRef = useRef(null);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .trim()
        .email("Revisa el email: debe tener el formato nombre@ejemplo.com")
        .required("Escribe tu email"),
      password: Yup.string().required("Escribe tu clave"),
    }),
    onSubmit: (values) => {
      // Limpia el error anterior: si el nuevo intento falla igual, el aviso
      // vuelve a aparecer y se nota que hubo respuesta.
      dispatch(apiError(""));
      dispatch(
        loginUser({ ...values, email: values.email.trim() }, props.router.navigate)
      );
    },
  });

  const { error, loading } = useSelector((state) => ({
    error: state.login.error,
    loading: state.login.loading,
  }));

  // Con una clave ya escrita (por ejemplo, autocompletada por el navegador)
  // no se esconde nada: esa persona ya entra con clave.
  const gmailNotice =
    isGmail(validation.values.email) && !usePassword && !validation.values.password;

  const signIn = (res, type) => {
    if (type === "google" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.token,
        idToken: res.token,
      };
      dispatch(socialLogin(postData, props.router.navigate, type));
    } else if (type === "facebook" && res) {
    }
  };

  const facebookResponse = (response) => {
    signIn(response, "facebook");
  };

  useEffect(() => {
    document.body.className = "bg-pattern";
    return function cleanup() {
      document.body.className = "";
    };
  });

  // No arrastrar un error viejo (de un intento anterior o de otra pantalla).
  useEffect(() => {
    dispatch(apiError(""));
  }, [dispatch]);

  // En un teléfono el aviso de error puede quedar fuera de la pantalla.
  useEffect(() => {
    if (error && alertRef.current) {
      alertRef.current.scrollIntoView({ block: "center", behavior: "smooth" });
    }
  }, [error]);

  return (
    <React.Fragment>
      <div className="bg-overlay"></div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card className="shadow" style={{ borderRadius: 12, border: "none" }}>
                <CardBody className="p-4">
                  <div className="text-center mb-4">
                    <Link to="/">
                      <img
                        src={logodark}
                        alt=""
                        height="50"
                        className="auth-logo logo-dark mx-auto"
                      />
                      <img
                        src={logolight}
                        alt=""
                        height="24"
                        className="auth-logo logo-light mx-auto"
                      />
                    </Link>
                    <h4 className="mt-3 mb-1" style={{ fontWeight: 700, color: "#333" }}>
                      ¡Bienvenidos!
                    </h4>
                    <p className="text-muted" style={{ fontSize: 14 }}>Elige cómo quieres entrar</p>
                  </div>

                  {error ? (
                    <div ref={alertRef}>
                      <Alert color="danger" className="d-flex align-items-center" style={{ borderRadius: 8 }}>
                        <span className="material-symbols-rounded me-2" style={{ fontSize: 20 }}>error</span>
                        <div>
                          {typeof error === "string"
                            ? error
                            : "No pudimos iniciar sesión. Vuelve a intentarlo en unos minutos."}
                        </div>
                      </Alert>
                    </div>
                  ) : null}

                  {/* Camino principal: quien tiene Gmail entra con Google, sin clave */}
                  <div
                    className="text-center"
                    style={{ background: "#f5f7fa", border: "1px solid #e3e8ef", borderRadius: 10, padding: 16 }}
                  >
                    <div style={{ fontWeight: 700, fontSize: 15, color: "#333" }}>
                      ¿Tu email es de Gmail?
                    </div>
                    <p className="text-muted mb-3" style={{ fontSize: 13 }}>
                      Toca el botón y elige tu cuenta de Gmail. No necesitas crear ni recordar una clave.
                    </p>
                    <GoogleButton />
                  </div>

                  <div className="d-flex align-items-center my-4">
                    <hr className="flex-grow-1 my-0" />
                    <span className="text-muted px-3" style={{ fontSize: 13, fontWeight: 600 }}>
                      ¿Tu email no es de Gmail?
                    </span>
                    <hr className="flex-grow-1 my-0" />
                  </div>

                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (!gmailNotice) validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="mb-3">
                      <Label className="form-label" style={{ fontWeight: 600, fontSize: 13 }}>
                        <span className="material-symbols-rounded me-1" style={{ fontSize: 16, verticalAlign: "middle" }}>mail</span>
                        Email
                      </Label>
                      <Input
                        name="email"
                        className="form-control"
                        placeholder="tu@email.com"
                        type="email"
                        style={{ borderRadius: 8, padding: "10px 14px" }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email ? true : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">
                          <div>{validation.errors.email}</div>
                        </FormFeedback>
                      ) : null}
                    </div>

                    {gmailNotice ? (
                      <GmailNotice
                        title="Este email es de Gmail"
                        skipLabel="Tengo una clave de Monitor"
                        onSkip={() => setUsePassword(true)}
                      >
                        No necesitas clave: toca el botón y elige tu cuenta de Gmail.
                      </GmailNotice>
                    ) : (
                      <>
                        <div className="mb-2">
                          <Label className="form-label" style={{ fontWeight: 600, fontSize: 13 }}>
                            <span className="material-symbols-rounded me-1" style={{ fontSize: 16, verticalAlign: "middle" }}>lock</span>
                            Clave de Monitor
                          </Label>
                          <PasswordInput
                            validation={validation}
                            placeholder="Ingresa tu clave"
                            autoComplete="current-password"
                          />
                          <div className="text-muted mt-1" style={{ fontSize: 12 }}>
                            Es la que creaste al registrarte aquí, no la de tu correo.
                          </div>
                        </div>

                        <div className="text-end mb-3">
                          <Link to="/forgot-password" className="text-muted" style={{ fontSize: 13 }}>
                            <span className="material-symbols-rounded me-1" style={{ fontSize: 14, verticalAlign: "middle" }}>lock_reset</span>
                            Olvidé mi clave
                          </Link>
                        </div>

                        <div className="d-grid">
                          <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={loading}
                            style={{ borderRadius: 8, padding: "10px", fontWeight: 600, fontSize: 15 }}
                          >
                            <span className="material-symbols-rounded me-1" style={{ fontSize: 18, verticalAlign: "middle" }}>login</span>
                            {loading ? "Ingresando…" : "Ingresar"}
                          </button>
                        </div>
                      </>
                    )}
                  </Form>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="text-white-50" style={{ fontSize: 14 }}>
                  ¿Primera vez sin Gmail?{" "}
                  <Link to="/register" className="fw-medium text-primary">
                    Crea tu cuenta
                  </Link>
                </p>
                <p className="text-white-50" style={{ fontSize: 12 }}>
                  © {new Date().getFullYear()} TicketControl Monitor - TicketControl Dev
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
